import * as React from 'react';
import {
    UitkHeading,
    UitkIcon,
    UitkSpacing
} from "@egencia/uitk-react";
import {ArticleDetails} from "./article-details";

export function Article({ article, className }) {
    return (
        <div className={`article ${className}`}>
            <UitkHeading tag="h1" size={5}>
                {!article.isFaq && (
                    <UitkSpacing padding={{inlineend: "one"}}>
                        <UitkIcon name="warning" />
                    </UitkSpacing>
                )}
                {article.title}
            </UitkHeading>
            <ArticleDetails article={article} />
        </div>
    )
}